<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: "App"
}
</script>

<style lang="scss">
// 项目公共样式
@import "@/assets/styles/public.scss";
@import "@/assets/styles/element-ui-reset.scss";
@import "./assets/font/font.css";

* {
  padding: 0;
  margin: 0;
  font-family: PingFang, serif;
}

html,
body {
  height: 100%;
}

#app {
  //font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //color: #2c3e50;
}

.menu > .el-menu-item.is-active {
  border-bottom: 0px solid #409EFF !important;
  font-weight: bold;
}

/*.menu>.el-menu--horizontal>.el-menu-item.is-active {
  //font-weight: bold;
}*/

/*.input>.el-input__inner {
  width: 172px;
  height: 33px;
  border-radius: 17px;
  border: 1px solid #8A8A8A;
}

.input1>.el-input__inner {
  border: 1px solid #8A8A8A;
}

.el-input__icon {
  font-size: 19px;
}*/

//显示时按钮样式
/*.el-button--inblack {
  //需要更改的按钮类型
  background: #34DCCE !important;
  border-color: #34DCCE !important;
  color: #fff !important;

  //移入时按钮样式
  &:hover {
    &:not(.is-disabled) {
      background: #5fded3 !important;
      border-color: #5fded3 !important;
      color: #FFF !important;
    }
  }
}

//禁用时按钮样式
.el-button--inblack.is-disabled {
  background: #9ee3dd !important;
  border-color: #9ee3dd !important;
  color: #FFF !important;
}

.el-button--inblack.is-plain {
  border: 1px solid #5fded3 !important;
  //背景透明
  background: transparent!important;
  color: #5fded3 !important;
}*/

//公共
.flex {
  display: flex;
}

.war-pe {
  flex-wrap: wrap;
}

.ju-sa {
  justify-content: space-around;
}

.ju-sp {
  justify-content: space-between;
}

.ju-cn {
  justify-content: center;
}

.ju-en {
  justify-content: end;
}

.al-cn {
  align-items: center;
}

.fl-co {
  flex-direction: column;
}

.al-top {
  align-items: flex-start; //上对齐
}
</style>
